// extracted by mini-css-extract-plugin
module.exports = {"errorPageWrapper":"FailedLoginErrorPage_errorPageWrapper__IxyTw","showboatLogo":"FailedLoginErrorPage_showboatLogo__3arVS"};